/*
 * @Description: 菜单配置说明  父级的 path = / , icon 请查看element plus的icon文档
 * @Author: 琢磨先生
 * @Date: 2024-07-12 10:03:09
 * @LastEditors: GW 1519964028@.qq.com
 * @LastEditTime: 2024-09-24 17:17:30
 */

import mywork from './menu_mywork'
import settings from './menu_settings'
import oa from './menu_oa'
import crm from './menu_crm'
import erp from './menu_erp'
import process from './menu_process'
import finance from './menu_finance'
import fixedAssets from './menu_fixedAssets'
// import wmg from './menu_wmg'
import operate from './menu_operate'
import kaijiang from './menu_kaijiang'
import kjtools from './menu_kjtools'
import order from './menu_order'
import onlineClass from './menu_onlineClass'
import adultEdu from './menu_adultEdu'
import academy from './menu_academy'
import accounting from './menu_accounting'
import essay from './menu_essay'

var menus = [
	{
		path: '/',
		icon: '',
		ignore: true, //忽略权限校验
		meta: {
			title: '首页'
		},
		name: 'HomeIndex',
		hideSide: true, //隐藏左侧菜单
		children: [
			{
				path: '/',
				icon: '',
				ignore: true, //忽略权限校验
				component: () => import('@/views/home'),
				meta: {
					title: '首页'
				}
			}
		]
	},
	{
		path: '/navigation',
		icon: '',
		ignore: true, //忽略权限校验
		meta: {
			title: '应用导航'
		},
		name: 'NavigationIndex',
		hideSide: true, //隐藏左侧菜单
		children: [
			{
				path: '/navigation',
				icon: '',
				ignore: true, //忽略权限校验
				component: () => import('@/views/home/navigation'),
				meta: {
					title: '应用导航'
				}
			}
		]
	},
	{
		path: '/dataCenter',
		icon: '',
		ignore: true, //忽略权限校验
		meta: {
			title: '数据中台'
		},
		name: 'DataCenterIndex',
		hideSide: true, //隐藏左侧菜单
		hideTop: true, //不在顶部导航展示，仅通过顶栏按钮进入
		children: [
			{
				path: '/dataCenter',
				icon: '',
				ignore: true, //忽略权限校验
				name: 'DataCenter',
				component: () => import('@/views/dataCenter/index.vue'),
				meta: {
						title: '数据中台'
				}
			},
			{
				path: '/dataCenter/detail',
				icon: '',
				ignore: true, //忽略权限校验
				name: 'DataCenterDetail',
				component: () => import('@/views/dataCenter/detail.vue'),
				meta: {
					title: '班次详情'
				}
			}
		]
	},
	mywork,
	oa,
	crm,
	// erp,
	finance,
	process,
	fixedAssets,
	// wmg,
	settings,
	operate,
	kaijiang,
	kjtools,
	order,
	onlineClass,
	adultEdu,
	academy,
	accounting,
	essay
]

//递归菜单处理每级菜单的url集合和菜单项id
var i = 0
menus.forEach((item) => {
	item.urls = []
	recursion(item, null, i++)
})

function recursion(item, father, i) {
	if (father) {
		item.id = `${father.id}-${i}`
	} else {
		item.id = '' + i
	}
	if (item.path && item.path != '/') {
		if (father) {
			father.urls.push(item.path)
		} else {
			item.urls = [item.path]
		}
	} else if (item.children) {
		var k = 0
		item.children.forEach((child) => {
			child.urls = []
			recursion(child, item, k++)
		})
	}
	if (father) {
		father.urls = [...father.urls, ...item.urls]
	}
}

export default menus
